<template>
  <transition name="right-slide">
    <div class="slide-box-agency"
         v-if="slide.show">
      <div class="mask"
           @click="getClose"></div>
      <div class="close-block"
           @click="getClose">
        <img src="/img/ui/close_gray.png"
             alt="">
      </div>
      <div class="slide-box-content">
        <div class="contentone">
          <div class="titlelist">
            {{slide.currentTypeName}}
          </div>
          <div class="titleintro">
            {{currentarea}}
            共
            <span v-if="jdofficelist.length">{{jdofficelist.length}}</span>
            <span v-else>0</span>
            家机构
            <button @click="areaselect.show = true">其它地区</button>
          </div>
          <template v-if="jdofficelist.length">
            <div :class="['item',index===aindex?'active':'']"
                 @click="getDetail(item,index)"
                 v-for="(item,index) in jdofficelist"
                 :key="'key-lists'+index">
              <div class="name txtone">
                {{item.name}}
              </div>
              <div class="address">
                <span class="glyphicon glyphicon-map-marker"></span>
                <p>{{item.address}}</p>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="empty-info">
              <p>
                如果想要查询其他州市 办理“{{slide.currentTypeName}}”的机构，请点击
              </p>
              <button @click="areaselect.show = true">
                查询其它州市机构
              </button>
            </div>
          </template>
        </div>
        <div class="contentwo">
          <div class="main">
            <template v-if="jdoffice">
              <div class="titledetail">
                {{jdoffice.name}}
              </div>
              <div class="contact">
                <p>地址：{{jdoffice.address}}</p>
                <p>电话：
                  <span>{{ jdoffice.tell||"暂无" }}</span>
                </p>
                <p>状态：{{jdoffice.field2}}</p>
              </div>
              <div class="detail-item">
                <div class="title">
                  专业
                </div>
                <div class="intro newspaper"
                     v-if="jdoffice.desc">
                  {{jdoffice.desc}}
                </div>
                <div class="introinfo"
                     v-else>
                  暂无
                </div>
              </div>
              <div class="detail-item">
                <div class="title">
                  机构地图
                </div>
                <div id="jd-map-container">

                </div>
              </div>
              <div class="detail-item">
                <div class="title">
                  机构人员
                </div>
                <div class="staff-box"
                     v-if="employeelist.length">
                  <a href="javascript:;"
                     @click="getPersonnel(staff)"
                     v-for="(staff,index) in employeelist"
                     :key="'key-s'+index">
                    {{staff.name}}
                  </a>
                </div>
                <div class="introinfo"
                     v-else>
                  暂无
                </div>
              </div>
            </template>
            <div class="emptyinfo"
                 v-else>
              <img src="/img/ui/emptyinfo2.png"
                   alt="">
              <p>请点击左边机构列表查看详情</p>
            </div>
          </div>
          <div class="footerslide">
            <slot name="footer">
              <div class="btns "
                   @click="getClose">
                <button>
                  返回
                </button>
              </div>
            </slot>
          </div>
        </div>
      </div>
      <Areaselect :areaselect="areaselect"
                  @getClose="areaselect.show=false "
                  @update="chooseArea "
                  v-if="areaselect.show"></Areaselect>
      <Dialogs v-model="dialog">
        <template slot="body">
          <div class="staffinfo">
            <div class="agencyname"
                 v-if="jdoffice.name">
              {{jdoffice.name}}
            </div>
            <template v-if="dialog.employee">
              <p>编号：{{dialog.employee.no}} </p>
              <p>技术职称：{{dialog.employee.title}} </p>
              <p>行业资格：{{dialog.employee.qualification}} </p>
              <p>执业类别：{{dialog.employee.industry_type}} </p>
            </template>
          </div>
        </template>
      </Dialogs>
    </div>
  </transition>
</template>
<script>
import Areaselect from '../../components/Areaselect'
import api from '../../datas/js/api.js'
import { TMap } from '../../datas/js/common.js'
import Dialogs from '../../components/Dialog'
export default {
  components: {
    Areaselect,
    Dialogs
  },
  /**
   * @property {Object} slide // {show：控制右滑组件的显示}
   * @property {Array} jdofficelist // 机构列表
   * @property {Number} aindex // 当前选中的机构的索引
   * @property {Object} areaselect // 控制地区组件的显示
   * @property {Object} jdoffice // 当前展示地图的机构
   * @property {Array} employeelist // 当前展示地图的机构人员列表
   * @property {Object} dialog // 弹窗显示
   *
   */
  props: {
    slide: Object,
    jdofficelist: Array
  },
  data () {
    return {
      currentarea: '',
      currentareacode: 0,
      aindex: '',
      areaselect: {
        show: false,
        showchild: false
      },
      jdoffice: '',
      employeelist: [],
      dialog: {
        show: false,
        title: '',
        cancelBtn: '关闭',
        close: true,
        employee: ''
      }
    }
  },
  methods: {
    getClose () {
      this.slide.show = false
      this.aindex = ''
      this.$emit('getClose')
    },
    async getDetail (item, index) {
      $('.main').scrollTop(0, 1000) // eslint-disable-line
      this.aindex = index
      this.jdoffice = item
      let data = await this.$get(api.jiandingemployee + item.id)
      this.employeelist = data.items
      this.getMap()
    },
    async getMap () {
      const dom = document.querySelector('#jd-map-container')
      if (dom.childNodes.length) {
        dom.childNodes[0].remove()
      }
      // 在此完成该函数
      const qq = await TMap(this.$root.webConfig.mapkey)
      const map = new qq.maps.Map(dom, {
        center: new qq.maps.LatLng(
          this.jdoffice.geography.split(',')[0],
          this.jdoffice.geography.split(',')[1]
        ),
        zoom: 17
      })
      // 地图点信息
      const infoWin = new qq.maps.InfoWindow({ map, zIndex: 10000 })
      const position = new qq.maps.LatLng(
        this.jdoffice.geography.split(',')[0],
        this.jdoffice.geography.split(',')[1]
      )
      const anchor = new qq.maps.Point(24, 50)
      const size = new qq.maps.Size(100, 100)
      const origin = new qq.maps.Point(0, 0)
      const scaleSize = new qq.maps.Size(48, 48)
      const icon = new qq.maps.MarkerImage(
        '/img/ui/position.png',
        size,
        origin,
        anchor,
        scaleSize
      )
      // 添加marker
      const marker = new qq.maps.Marker({
        position,
        map,
        animation: qq.maps.MarkerAnimation.DOWN
      })
      // const infotmp = this.setMapContent(masData[i])
      // 加载marker图标
      marker.setIcon(icon)
      let tell = this.jdoffice.tell
      if (!tell) {
        tell = '暂无'
      }
      infoWin.open()
      infoWin.setContent(`<div class="map-marker-info" style="padding:0 0 10px;">
          <h2 style="font-size:18px; margin:0 0 10px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">${this.jdoffice.name}</h2>
          <div style="color:#808080; font-size:16px;">
            <strong>状态：</strong>${this.jdoffice.field2} <br>
            <strong>地址：</strong>${this.jdoffice.address} <br>
            <strong>电话：</strong>${tell}
          </div>
        </div>`)
      infoWin.setPosition(map.getCenter())
    },
    chooseArea (value) {
      this.currentarea = value[0].label
      this.jdoffice = ''
      this.employeelist = []
      this.aindex = ''
      this.$emit('updatedoffice', value[0].code)
    },
    getPersonnel (employee) {
      this.dialog.show = true
      this.dialog.title = employee.name
      this.dialog.employee = employee
    }
  },
  mounted () {
    this.currentarea = this.$store.state.device.config.web_area
  }

}
</script>

<style lang="stylus">
// 右边的弹窗
.slide-box-agency {
  display: flex;
  justify-content: flex-end;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 400;
  transition: all 0.3s;
  &.right-slide-enter-active, &.right-slide-leave-active {
    .slide-box-content, .footerslide, .close-block {
      transition: transform 0.3s;
    }
    .mask {
      transition: opacity 0.3s;
    }
  }
  &.right-slide-enter, &.right-slide-leave-to {
    .slide-box-content, .footerslide, .close-block {
      transform: translateX(100%);
    }
    .mask {
      opacity: 0;
    }
  }
  .close-block {
    position: absolute;
    top: 0.2rem;
    right: 0.3rem;
    width: 0.4rem;
    height: 0.4rem;
    text-align: center;
    z-index: 10;
    img {
      width: 0.3rem;
    }
  }
  .slide-box-content {
    height: 100%;
    position: relative;
    background: #fff;
    &::-webkit-scrollbar {
      display: none;
      width: 0 !important;
    }
    .contentone {
      float: left;
      height: 100%;
      overflow-y: scroll;
      width: 5rem;
      border-right: 1px solid #ccc;
      .titlelist {
        font-size: 0.26rem;
        line-height: 1.6;
        box-sizing: border-box;
        color: #000;
        font-weight: 600;
        padding: 0.38rem 0.28rem 0.1rem 0.28rem;
      }
      .titleintro {
        padding-left: 0.28rem;
        font-size: 0.2rem;
        color: #666;
        line-height: 0.36rem;
        margin-bottom: 0.15rem;
        span {
          color: #3b6ae0;
        }
        button {
          width: 1rem;
          height: 0.36rem;
          color: #3b6ae0;
          text-align: center;
          font-size: 0.2rem;
          background: #fff;
          margin-left: 0.2rem;
          border-radius: 0.06rem;
          border: solid 1px #3b6ae0;
        }
      }
      .item {
        box-sizing: border-box;
        overflow: hidden;
        position: relative;
        line-height: 1.6;
        font-size: 0.2rem;
        padding: 0.3rem 0.28rem;
        color: #000;
        border-bottom: 1px solid #e5e5e5;
        .name {
          font-size: 0.24rem;
          color: #000;
        }
        .address {
          display: flex;
          align-items: baseline;
          font-size: 0.18rem;
          margin-top: 0.1rem;
          color: #666;
          span {
            color: #999;
            margin-right: 0.08rem;
          }
        }
        &.active {
          background: #e6eaf2;
          .name {
            color: #3b6ae0;
          }
        }
      }
      .empty-info {
        padding: 1.5rem 0.2rem 0 0.2rem;
        font-size: 0.2rem;
        text-align: center;
        line-height: 1.6;
        button {
          margin-top: 0.2rem;
          background: #fff;
          padding: 0.05rem 0.24rem;
          border-radius: 0.06rem;
          border: solid 1px #ccc;
        }
      }
    }
    .contentwo {
      height: 100%;
      float: left;
      display: flex;
      flex-direction: column;
      width: 7rem;
      .main {
        flex: 1;
        overflow-y: scroll;
        padding: 0 0.3rem;
      }
      .titledetail {
        font-size: 0.32rem;
        line-height: 0.32rem;
        font-weight: 600;
        padding: 0.6rem 0.1rem 0.3rem 0.1rem;
      }
      .contact {
        font-size: 0.18rem;
        padding: 0 0.1rem;
        color: #666;
        line-height: 1.6;
      }
      .detail-item {
        color: #333;
        padding: 0 0.1rem;
        &:last-child {
          padding: 0;
          .title {
            padding: 0.5rem 0.1rem 0.2rem 0.1rem;
          }
        }
        .title {
          font-size: 0.24rem;
          font-weight: 600;
          padding: 0.5rem 0 0.2rem 0;
        }
        .intro {
          font-size: 0.22rem;
          line-height: 1.6;
        }
        .introinfo {
          padding: 0 0.1rem;
          color: #999;
        }
        #jd-map-container {
          height: 2.6rem;
          background-color: #e6eaf2;
          border-radius: 0.1rem;
        }
        .staff-box {
          display: flex;
          flex-wrap: wrap;
          a {
            display: block;
            width: 1.3rem;
            text-align: center;
            line-height: 0.45rem;
            height: 0.46rem;
            font-size: 0.2rem;
            color: #333;
            background-color: #fcfdff;
            border-radius: 0.08rem;
            border: solid 0.01rem #cccccc;
            margin: 0 0.1rem 0.2rem 0.1rem;
          }
        }
      }
      .emptyinfo {
        text-align: center;
        padding-top: 2.9rem;
        p {
          color: #999;
          font-size: 0.22rem;
          margin-top: 0.2rem;
        }
      }
    }
  }
  .footerslide {
    background: #fff;
    position: relative;
    .btns {
      position: relative;
      padding: 0.3rem 0.4rem;
      background: #fff;
      button {
        height: 0.6rem;
        width: 100%;
        text-align: center;
        line-height: 0.6rem;
        background-color: #3b6ae0;
        border-radius: 0.1rem;
        font-size: 0.32rem;
        color: #fff;
      }
    }
  }
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
  }
  .staffinfo {
    width: 6rem;
    padding-bottom: 0.3rem;
    .agencyname {
      text-align: center;
      font-size: 0.2rem;
      padding-bottom: 0.6rem;
      color: #666;
    }
    p {
      font-size: 0.22rem;
      line-height: 1.6;
      color: #333333;
    }
  }
}
</style>
